<template>
    <div
        :class="{
            'commercial-paper': true,
            'padded-page': true,
            none: reviewData?.total_cp <= 0,
        }"
        ref="screenWrapper"
    >
        <div class="mb-5 text-white font-satoshi_r max-w-xs">
            <p class="text-lg">You didn't invest in Commercial Papers in 2025.</p>
        </div>
        <template v-if="reviewData?.total_cp > 0">
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg">Sycamore paid you</p>
                <p class="text-4xl font-satoshi_b font-bold my-2"><CountUpNumber :endVal="reviewData?.cp_returns ?? 0" currency="₦" /></p>
                <p>in CP returns.</p>
            </div>
        </template>
        <template v-else>
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg mb-5">Invest in commercial papers from trusted companies, carefully vetted and selected by us.</p>
                <p class="text-lg">Start with as low as ₦100,000 and watch your money grow in no time.</p>
            </div>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.commercial-paper {
    color: #fcfcde;
    min-height: 100vh;

    background-color: #266cfe;
    background-image: url("../../assets/images/year-in-review/commercial-paper.svg");
    background-size: 85% 55%;
    background-repeat: no-repeat;
    background-position: bottom right;
}

.commercial-paper.none {
    background-image: url("../../assets/images/year-in-review/commercial-paper-none.svg");
}

@media (max-height: 750px) {
    .commercial-paper {
        background-size: 85% 45%;
    }
}
</style>
